import type { Moment } from 'moment';
import { memo } from 'react';

import type { Appointment } from '@wecasa/common/src/types/commons';
import { getAppointmentsSortedByDay } from '@wecasa/common/src/utils/appointment';
import { getRecurrenceDescription } from '@wecasa/common/src/utils/cleaning';

import Text from '@wecasa/web-ui/src/components/base-text/variants/text';

import { Day, DaysList, Slots } from '../../../../common/common';
import Slot from '../../../../common/sections/appointments/slot';

type TitleProps = {
  day: Moment;
  weeklyRecurrence: number | null;
};

const getTitle = ({ day, weeklyRecurrence }: TitleProps) => {
  if (!day) {
    return '';
  }
  return getRecurrenceDescription(day, weeklyRecurrence);
};

type CleaningAppointmentDetailsProps = {
  appointment: Appointment;
  weeklyRecurrence: number | null;
};

const MultipleCleaningAppointmentDetails = ({
  appointment: { primary, secondary },
  weeklyRecurrence,
}: CleaningAppointmentDetailsProps) => (
  <DaysList>
    {getAppointmentsSortedByDay(primary, secondary).map(({ day, slots }) => (
      <Day key={day.toISOString()}>
        <Text.MDBold>{getTitle({ day, weeklyRecurrence })}</Text.MDBold>
        <Slots>
          {slots.map(({ text, isPrimary, label }) => (
            <Slot key={label} text={text} isPrimary={isPrimary} label={label} />
          ))}
        </Slots>
      </Day>
    ))}
  </DaysList>
);

export default memo(MultipleCleaningAppointmentDetails);
